import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export default function RefundPolicyPage() {
  return (
    <div style={{ 
      position: 'relative', 
      zIndex: 1, 
      paddingTop: '100px',
      paddingBottom: '80px',
      minHeight: '100vh',
      background: '#0a1628',
    }}>
      <div style={{ maxWidth: '720px', margin: '0 auto', padding: '0 24px' }}>
        <Link
          to="/"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            color: 'var(--vvs-muted)',
            textDecoration: 'none',
            fontSize: '11px',
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            fontFamily: 'Space Grotesk',
            marginBottom: '40px',
            transition: 'color 0.3s',
          }}
          onMouseEnter={e => e.currentTarget.style.color = '#F0F4F8'}
          onMouseLeave={e => e.currentTarget.style.color = 'var(--vvs-muted)'}
        >
          <ChevronLeft size={14} /> Home
        </Link>

        <h1 style={{
          fontFamily: 'Syne, sans-serif',
          fontWeight: 800,
          fontSize: 'clamp(32px, 6vw, 48px)',
          textTransform: 'uppercase',
          color: '#F0F4F8',
          marginBottom: '16px',
          letterSpacing: '-0.02em',
        }}>
          Refund Policy
        </h1>

        <p style={{ 
          fontFamily: 'Space Grotesk', 
          fontSize: '12px', 
          color: 'var(--vvs-muted)', 
          marginBottom: '48px',
          letterSpacing: '0.1em',
        }}>
          Last updated: February 2026
        </p>

        <p style={{ 
          fontFamily: 'Space Grotesk', 
          fontSize: '14px', 
          color: 'var(--vvs-muted)', 
          lineHeight: 1.9,
          marginBottom: '16px',
        }}>
          Nothing in this policy affects your statutory rights under applicable Belgian and European consumer protection law.
        </p>

        <p style={{ 
          fontFamily: 'Space Grotesk', 
          fontSize: '14px', 
          color: '#F0F4F8', 
          lineHeight: 1.9,
          marginBottom: '40px',
        }}>
          All ticket sales for Vague Vision Sound events are generally final. Please read this policy carefully before purchasing.
        </p>

        <div style={{ color: '#F0F4F8', fontFamily: 'Space Grotesk, sans-serif', fontSize: '14px', lineHeight: 1.9 }}>
          <Section number="1" title="No Refunds // General Rule">
            <p style={{ marginBottom: '12px' }}>VVS does not generally offer refunds for:</p>
            <List items={[
              'Change of mind or personal circumstances',
              'Scheduling conflicts',
              'Late arrival or denied entry (see Event Terms)',
              'Dissatisfaction with the event experience',
              'Changes to the program, lineup, or artists, unless such changes constitute a material alteration as required by applicable law',
            ]} />
            <p style={{ color: 'var(--vvs-muted)', marginTop: '16px', fontStyle: 'italic', fontSize: '13px' }}>
              Note: tickets for live entertainment events at a fixed date are generally exempt from the statutory right of withdrawal under European consumer law (Directive 2011/83/EU), as implemented in Belgian law.
            </p>
          </Section>

          <Section number="2" title="Cancellation by VVS">
            <p style={{ color: 'var(--vvs-muted)' }}>
              If VVS cancels an event entirely, ticket holders will receive a full refund of the face value of their ticket (excluding service fees charged by third-party ticketing platforms, which are subject to those platforms' own policies). Refunds will be processed within 14 to 30 days of the cancellation announcement.
            </p>
          </Section>

          <Section number="3" title="Postponement by VVS">
            <p style={{ color: 'var(--vvs-muted)' }}>
              If an event is postponed, original tickets remain valid for the rescheduled date. Ticket holders who cannot attend the new date may request a refund within 14 days of the postponement announcement.
            </p>
          </Section>

          <Section number="4" title="Unauthorized Resale">
            <p style={{ color: 'var(--vvs-muted)' }}>
              Resale of tickets above face value is prohibited. VVS reserves the right to cancel resold tickets without refund.
            </p>
          </Section>

          <Section number="5" title="Contact">
            <p>For any refund-related request:</p>
            <p>contact@vaguevisionsound.com</p>
            <p style={{ marginTop: '12px' }}>Vague Vision Sound ASBL</p>
            <p>Rue du Trône 214/7, 1050 Ixelles, Brussels</p>
            <p style={{ color: 'var(--vvs-muted)', marginTop: '16px' }}>
              All requests are handled in good faith and in accordance with applicable Belgian consumer protection law.
            </p>
          </Section>
        </div>
      </div>
    </div>
  );
}

function Section({ number, title, children }) {
  return (
    <div style={{ marginBottom: '40px' }}>
      <h2 style={{
        fontFamily: 'Syne, sans-serif',
        fontWeight: 700,
        fontSize: '16px',
        textTransform: 'uppercase',
        color: 'var(--vvs-cyan)',
        marginBottom: '16px',
        letterSpacing: '0.08em',
      }}>
        {number}. {title}
      </h2>
      {children}
    </div>
  );
}

function List({ items }) {
  return (
    <ul style={{ margin: 0, paddingLeft: '20px' }}>
      {items.map((item, i) => (
        <li key={i} style={{ color: 'var(--vvs-muted)', marginBottom: '8px' }}>{item}</li>
      ))}
    </ul>
  );
}
